module.exports = __webpack_public_path__ + "static/media/community-builder-6.381304e3.jpg";